import Avatar from "component/avatar";

import { SmallLogo, NGIcon, EUIcon, UKFlag } from "asset/icons";
import { formatDate } from "component/flex/utils";
import capitalizeWords from "utilities/capitalizeWords";
import generateId from "utilities/generateId";
import { useState } from "react";
import { invoiceItemAmountCalculation } from "./CreateInvoice";
import { useLocation } from "react-router-dom";
import { formatMoney } from "utilities/formatMoney";
import currencyPairCheck from "utilities/currencyPairCheck";
import useUserDetails from "hooks/useUserDetails";

const PreviewInvoice = ({
    data,
    business,
    user,
    itemAmountCalculation,
    total,
    subTotal,
    taxedTotal,
    addTax = false,
}) => {
    const [id] = useState(generateId(5, true));
    const { state } = useLocation();
    const { isEdit } = state || {};
    const accountName = capitalizeWords(
        `${business?.name ?? `${user?.firstName ?? ""} ${user?.lastName ?? ""}`}`
    );
    const accountNameArr = accountName?.split(" ");
    const accountImg =
        accountName === capitalizeWords(business?.name ?? "")
            ? business?.businessImage?.url
        : user?.profileImage?.url;
  const { userWalletsAccounts } = useUserDetails()
    const {
        selectedSupplier,
        issueDate,
        dueDate,
        selectedCurrency,
        items,
        invoiceDataToEdit,
        ...rest
    } = data;
  const currentAccountDetails = userWalletsAccounts?.find((account) => account?.currency === selectedCurrency)?.providers?.[0]
  const isStable = currentAccountDetails?.type === "STABLE";

    const { paymentInfo } = selectedSupplier || {};
    const { bankName, accountNumber, accountName: supplierAccountName } = paymentInfo?.[0] || {};
    const isEmpty = !items?.[0]?.itemName === "";
    const businessToSendTo =
        business?._id === selectedSupplier?.business?._id
            ? selectedSupplier?.receiverBusiness
            : selectedSupplier?.business;

    return (
        <div className="w-full md:w-[45%]">
            <h6 className="mb-3 text-xl font-normal text-secondary-40">Preview</h6>

            <div
                className="mt-3 bg-white border rounded-lg border-secondary-10"
                style={{
                    boxShadow: "0px 16px 64px 0px #3F434B24",
                }}
            >
                <div className="flex items-center justify-between px-4 py-4">
                    <p className="text-main-dark font-[450] text-base">
                        Invoice
                        <span className="text-secondary-40">[TIN-{id}]</span>
                    </p>

                    <SmallLogo />
                </div>
                <div
                    className="w-full h-1"
                    style={{
                        background:
                            "linear-gradient(203.96deg, rgba(125, 20, 255, 0.6) 0.88%, rgba(94, 1, 214, 0.6) 66.2%)",
                    }}
                ></div>
                <div className="px-3 py-4 ">
                    <div className="flex items-start justify-between gap-4 mb-4">
                        <div className="w-1/2">
                            <h6 className="flex items-center justify-start">
                                <Avatar
                                    img={accountImg}
                                    className={`${
                                        accountNameArr?.length > 3 && "text-[10px] "
                                    } size-[42px] block`}
                                    fullName={accountName}
                                />
                                {accountName}
                            </h6>

                            <div className="mt-4">
                                <p className="text-sm font-light text-gray-70">
                                    <span>Issued:</span> {formatDate(issueDate, "MMM D, YYYY")}
                                </p>
                                <p className="text-sm font-light text-gray-70">
                                    <span>Due:</span> {formatDate(dueDate, "MMM D, YYYY")}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/2">
                            <p className="mb-2 text-sm font-medium text-gray-90">To</p>
                            <p className="text-sm font-medium capitalize text-gray-90">
                                {businessToSendTo?.name ? businessToSendTo?.name : "--"}
                            </p>
                            <p className="text-sm font-light text-secondary-40">
                                {typeof businessToSendTo?.address === "string"
                                    ? businessToSendTo?.address
                                    : businessToSendTo?.address?.[0]
                                    ? businessToSendTo?.address?.join(", ")
                                    : businessToSendTo?.businessAddress?.[0]
                                    ? businessToSendTo?.businessAddress?.[0]
                                    : businessToSendTo?.email}
                            </p>
                            <p className="text-sm font-light text-secondary-40">
                                {businessToSendTo?.businessNature}
                            </p>
                            <p className="text-sm font-light text-secondary-40">
                                {businessToSendTo?.country}
                            </p>
                        </div>
                    </div>
                    {/* Table section */}
                    <div className="mb-4 border rounded-md border-light-grey">
                        <div className="flex items-center p-3 rounded-md bg-bg-color-10">
                            <p className="w-4/12 text-xs font-medium text-gray-90">Items</p>
                            <p className="w-2/12 text-xs font-medium text-gray-90">Quantity</p>
                            <p className="w-3/12 text-xs font-medium text-gray-90">Unit price</p>
                            <p className="w-3/12 text-xs font-medium text-gray-90">Total</p>
                        </div>
                        {isEmpty ? (
                            <div className="flex items-center px-3 py-3 rounded-md">
                                <p className="w-full text-base font-light text-center text-gray-90">
                                    Item list is empty
                                </p>
                            </div>
                        ) : (
                            items?.map((item, index) => {
                                const { itemName, pricePerUnit, quantity } = item;
                                return (
                                    <div
                                        key={index}
                                        className="flex items-center px-3 py-3 rounded-md odd:bg-bg-color-10"
                                    >
                                        <p className="w-4/12 text-base font-light text-gray-90">
                                            {itemName ? itemName : "--"}
                                        </p>
                                        <p className="w-2/12 text-base font-light text-center text-gray-90">
                                            {quantity ? quantity : "--"}
                                        </p>
                                        <p className="w-3/12 text-base font-light text-gray-90">
                                      {currencyPairCheck(selectedCurrency)} {pricePerUnit ? pricePerUnit : "--"}
                                        </p>
                                        <p className="w-3/12 text-base font-light text-gray-90">
                                            {itemAmountCalculation
                                                ? itemAmountCalculation?.(item)
                                                : invoiceItemAmountCalculation?.(
                                                      item,
                                                      rest?.currency
                                                  )}
                                        </p>
                                    </div>
                                );
                            })
                        )}
                        {addTax ? (
                            <div className="flex items-center justify-end w-8/12 px-3 py-3 ml-auto rounded-md">
                                <p className="w-1/2 ml-auto text-sm font-light text-start text-secondary-40">
                                    Subtotal
                                </p>
                                <p className="w-1/2 text-sm font-light text-center text-gray-90">
                                    {subTotal}
                                </p>
                            </div>
                        ) : null}
                        {addTax ? (
                            <div className="flex items-center justify-end w-8/12 px-3 py-3 ml-auto bg-bg-color-10">
                                <p className="w-1/2 ml-auto text-sm font-light text-start text-secondary-40">
                                    VAT (7.5%)
                                </p>
                                <p className="w-1/2 text-sm font-light text-center text-gray-90">
                                    {taxedTotal}
                                </p>
                            </div>
                        ) : null}
                        {isEdit && invoiceDataToEdit?.paidAmount > 0 ? (
                            <div className="flex items-center justify-end w-8/12 px-3 py-3 ml-auto rounded-md">
                                <p className="w-1/2 ml-auto text-sm font-light text-start text-secondary-40">
                                    Paid
                                </p>
                                <p className="w-1/2 text-sm font-light text-center text-gray-90">
                                    {selectedCurrency}
                                    {formatMoney(invoiceDataToEdit?.paidAmount)}
                                </p>
                            </div>
                        ) : null}
                        <div className="flex items-center justify-end w-8/12 px-3 py-3 ml-auto bg-bg-color-10">
                            <p className="w-1/2 ml-auto text-sm font-light text-start text-secondary-40">
                                Total
                            </p>
                            <p className="w-1/2 text-sm font-bold text-center text-gray-90">
                                {total}
                            </p>
                        </div>
                    </div>

                    <p className="mb-3 text-base font-light text-gray-70">
                        Complete payment for this invoice using any of the options below.
            </p>

            {currentAccountDetails ? (
              <div className="flex flex-col  w-full max-w-full gap-2 mt-4">
                            <label
                                htmlFor="Invoice"
                                className="text-[#344054] font-[450] text-sm leading-[19.6px]"
                            >
                                Bank transfer
                            </label>
                <div className="relative items-start overflow-hidden grid grid-cols-3 gap-2 p-3 bg-transparent border rounded-md border-light-grey">
                                <div className="">
                                    <p className="text-sm font-light text-start text-secondary-40">
                                        Account name
                                    </p>
                                    <p className="text-sm font-medium text-left text-gray-90">
                      {currentAccountDetails?.accountName ? currentAccountDetails?.accountName : '--'}
                                    </p>
                                </div>
                  {!isStable && <div>
                                    <p className="text-sm font-light text-start text-secondary-40">
                                        Bank name
                                    </p>
                                    <p className="text-sm font-medium text-left text-gray-90">
                      {currentAccountDetails?.bankName ? currentAccountDetails?.bankName : '--'}
                                    </p>
                  </div>}
                                <div>
                                    <p className="text-sm font-light text-start text-secondary-40">
                      {isStable ? "Wallet Address" : "Account Number"}
                                    </p>
                    <p className="text-sm font-medium break-all text-left text-gray-90">
                      {currentAccountDetails?.accountNumber ? currentAccountDetails?.accountNumber : '--'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    <div className="mt-3 space-y-4">
                        <h2 className="text-xl text-[#6F00FF] font-light">Thank you!</h2>
                        <p className="space-x-1 text-xs font-light text-gray-500">
                            <span>
                                If you have questions for us, please call a representative on
                            </span>
                            <a
                                href="tel:+2347073183321"
                                className="!text-[#6F00FF]  hover:underline"
                            >
                                +2347073183321
                            </a>{" "}
                            or
                            <a
                                href="tel:+447903175084"
                                className="!text-[#6F00FF]  hover:underline"
                            >
                                +447903175084
                            </a>
                            <span>
                                You can also send us an email at{" "}
                                <a
                                    href="mailto:hello@tradevu.co"
                                    className="!text-[#6F00FF]  hover:underline"
                                >
                                    hello@tradevu.co
                                </a>
                                .
                            </span>
                        </p>
                    </div>

                    <div className="mt-4">
                        <p className="space-x-1 text-xs font-light text-gray-500">
                            <span>Our operating locations</span>
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                            <NGIcon className="size-4" />
                            <UKFlag className="size-4" />
                            <EUIcon className="size-4" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviewInvoice;
